export enum LogicalOperand {
    And = 'And',
    Or = 'Or'
}

export enum Operand {
    Include = 'Include',
    Exclude = 'Exclude',
    Should = 'Should'
}
